/**
 * @Author: wuyang
 * @Date: 2024/1/15
 * @Description: ""
 */

import { ETaskStatus } from '@/types/task'

export const canDelTask = (status?: ETaskStatus) => {
	return (
		status === ETaskStatus.editing ||
		status === ETaskStatus.success ||
		status === ETaskStatus.fail ||
		status === ETaskStatus.ai ||
		status === ETaskStatus.queue ||
		status === ETaskStatus.execute||
		status === ETaskStatus.modifying
	)
}
